import React from 'react';

import {
    Grid,
    Paper,
    Stack,
    Typography,
    Chip,
    Box
} from '@mui/material';

import { lightBlue, blueGrey } from '@mui/material/colors';

import DiscountTwoToneIcon from '@mui/icons-material/DiscountTwoTone';

import { motion } from 'framer-motion';
// Framer Motion 애니메이션 Variants
const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { 
        y: 0, 
        opacity: 1,
        transition: { duration: 0.6, ease: "easeOut" }
    }
};

// 이미지 애니메이션 Variants
const imageVariant = {
    rest: { scale:1 },
    hover: { scale:1.1 } // 위로 15% 이동
};

export default function EnterpriseCard(props){

    const link = "/company/contact";

    return (
        <Grid size={{
                xs : 12,
                sm : 6,
                md : 4
            }}>
            <Paper
                className="da-box-shadow"
                elevation={2}
                sx={{position:'relative',overflow:'hidden', width:'100%', paddingBottom:'100%', borderRadius:'16px', backgroundColor:lightBlue[600]}}>
                <Box
                    component="a"
                    href={link}
                    sx={{ textDecoration: 'none', overflow:'hidden' }}>
                        <Box
                            sx={{posiiton:'absolute', width:'100%', height:'100%', overflow:'hidden'}}
                            component={motion.div}
                            initial="rest"
                            whileHover="hover"
                            animate="rest">
                            {/* 이미지 */}
                            <Box
                                component={motion.div}
                                variants={imageVariant}
                                transition={{ duration: 0.4, ease: 'easeInOut' }}
                                sx={{ 
                                    position: 'absolute', 
                                    right: 0, bottom: 0, 
                                    width: '100%', 
                                    height: '100%',
                                    overflow:'hidden' }}
                            >
                                <img src={"/assets/images/home/enterprise_image.jpg"} alt={`${"cleaning cart"} 2`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                            </Box>
                            <Box
                                sx={{
                                position:'absolute', width:'100%', height:'100%', borderRadius:'16px',
                                background:'linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,200))'
                                }}>
                            </Box>
                        </Box>
                <Stack
                sx={{position:'absolute', bottom:'24px', left:'24px'}}
                direction="column"
                className="da-button-arrow"
                justifyContent="flex-start"
                alignItems="flex-start"
                component={motion.div}
                variants={cardVariants}
                // ✅ 카드 전체에 대한 호버 효과는 미세하게 조정 (살짝 위로)
                whileHover={{ y: -5 }}
                transition={{ duration: 0.3 }}
                spacing={.5}>
                <Typography
                    sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:700,
                    fontSize:'15px',
                    textAlign:'left',
                    color:'#ddd'}}>
                    도입 문의
                </Typography>
                <Typography
                    sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:900,
                    fontSize:'24px',
                    textAlign:'left',
                    color:'#ffffff'
                    }}>
                    기업을 위한 플랜
                </Typography>
                <Typography
                    sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:500,
                    fontSize:'16px',
                    textAlign:'left',
                    color:'#ffffff'
                    }}>
                    환경을 위해 기업을 위한 플랜을 준비했습니다
                </Typography>
                </Stack>
                </Box>
            </Paper>
        </Grid>
    );
}